import React from 'react';
import HeroStyle2 from '../../Hero/HeroStyle2';
import Section from '../../Section';
import AboutSectionStyle3 from '../../Section/AboutSection/AboutSectionStyle3';
import WorkingProcess from '../../Section/WorkingProcess';
import BannerSectionStyle2 from '../../Section/BannerSection/BannerSectionStyle2';
import AppointmentSectionStyle2 from '../../Section/AppointmentSection/AppointmentSectionStyle2';
import generalvideo from "../../Images/generalvideo.mp4"
import { pageTitle } from '../../../helpers/PageTitle';
import FunFactSection from '../../Section/FunFactSection';
import funfact from "../../Images/funfact.jpeg";
import clinic3 from "../../Images/bg/clinic3.jpg";
import about from "../../Images/about.png";
import a23 from "../../Images/a23.jpg";
import a2 from "../../Images/a2.png";

const testimonialData = [
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
    {
        text: 'I recently had to bring my child to ProHealth for a minor injury, and I was so impressed with the care he received. The pediatrician was great with him and made him feel at ease, and the entire staff was kind and attentive.”',
        ratingNumber: '4.5',
        avatarImgUrl: '/images/home_1/avatar_2.png',
        avatarName: 'PAULO HUBERT',
        avatarDesignation: 'New York, USA',
    },
];

const funFactData = [
    { number: '15+', title: 'Years of experience' },
    { number: '1.6 Cr', title: 'Patient Registration' },
    { number: '700000+', title: 'Transactions per day.' },
    { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
    { number: '5+', title: 'Countries Customers' },
];

const workingProcessData = [
    {
        title: 'Appointment Scheduling and Billing',
        subTitle:
            'Easy, robust and can be accessed through multiple faces of workflow enables' +
            'Patient / Clinic Receptionist /Clinic Doctor to schedule appointment and make payment' +
            'through personalized payment gateway. Monitor patient needs, timing and better inform' +
            'patients on any change in doctor schedule, once in clinic premise manage their life cycle' +
            'through better queue management system. Billing the patient with right information and ease ' +
            'of collecting various information to make collection of billing claims easy and accurate.' +
            'Provide needed incentives and information to patient becomes key factor for patient satisfaction' +
            'from billing perspective.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_1.svg',
        number: '01',
    },
    {
        title: 'Electronic Medical Records (EMR)',
        subTitle:
            'Manage patients’ medical history through the EMR with configurable multi-specialty support.' +
            'EMR provides an easy way to access patient summary while maintaining strong confidentiality ' +
            'of patient records through role based access controls. Scan and upload documents to EMR from' +
            'visits to other clinics for documenting relevant medical history. Covers all aspects such as' +
            'chief complaints, investigations, observations, treatments, clinical reminders, diagnosis and' +
            'follow up plans.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_2.svg',
        number: '02',
    },
    {
        title: 'Managing Multiple Locations',
        subTitle:
            'One point access for clinics at multiple locations controlling the clinic/s from anywhere' +
            'using Role based access system for users like front desk, doctors etc.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_3.svg',
        number: '03',
    },
    {
        title: 'Ease of Integration',
        subTitle:
            'Medna Data Systems provides various integration options with physical devices, simple appointment' +
            'queue management system integration with Kiosk, bio-medical devices integration and having' +
            'patient monitored passively are key benefits of integrated solution. No Symptoms are ignored' +
            'in process of these integration.',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/wording_process_icon_4.svg',
        number: '04',
    },
];
const blogData = [
    {
        title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
        thumbUrl: 'images/home_1/post_1.jpeg',
        date: 'May 1, 2023',
    },
    {
        title: 'Healthy Eating on a Budget: Tips and Strategies',
        thumbUrl: 'images/home_1/post_2.jpeg',
        date: 'May 4, 2023',
    },
    {
        title: 'The Importance of Regular Cancer Screenings and Early Detection',
        thumbUrl: 'images/home_1/post_3.jpeg',
        date: 'May 1, 2023',
    },
];
const faqData = [
    {
        title: 'What services does ProHealth offer?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I schedule an appointment with ProHealth?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'Do you accept insurance?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'What should I bring to my appointment?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
    {
        title: 'How do I request a prescription refill?',
        content:
            'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesent voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui.',
    },
];
const brandData = [
    {
        imgUrl: '/images/brand_1.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_2.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_3.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_4.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_5.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_6.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_7.png',
        imgAlt: 'Brand',
    },
];
export default function Clinic() {
    pageTitle('Home V2');
    return (
        <>
            <HeroStyle2
                title="Clinic Solutions"
                subTitle="The primary objective of independent medical practices is to move patients
                 through the practice efficiently and easily.Research indicates managing cost effectiveness
                  while maintaining practice growth and patient satisfaction is one of the biggest challenges
                   faced by small clinics. Eventually, rapid growth in number of patients without adequate scale
                    up of supporting systems induces gaps leading to poor service to patients.Eventually,
                     rapid growth in number of patients without adequate scale up of supporting systems
                     induces gaps leading to poor service to patients."
                bgUrl={clinic3}
                imgUrl={process.env.PUBLIC_URL + "/images/home_2/patents.png"}
            // btnText="Doc Choice"
            // btnUrl="/"
            />

            <Section topMd={175} topLg={125} topXl={85}>
                <FunFactSection
                    bgUrl={funfact}
                    data={funFactData}
                />
            </Section>
            {/* <Section
        className="cs_bg_filed"
        style={{ backgroundImage: `url(/images/home_2/testimonial_bg.svg)` }}
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSectionStyle2
          sectionTitle="What Are the Benefits of <br /> Electronic Health Records?"
          sectionTitleUp="BENEFITS"
          data={testimonialData}
        />
      </Section> */}
            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <WorkingProcess
                    sectionTitle="What Are the Benefits of Electronic Health Records?"
                    sectionTitleUp=""
                    sectionTitleDown=""
                    sectionSubTitle="Examples of the numerous benefits of electronic medical records 
          in hospitals and other healthcare facilities include"
                    data={workingProcessData}
                />
            </Section>
            <Section>
                <BannerSectionStyle2
                    bgUrl={a23}
                    title="Don’t Let Your Hospital <br />Take a Backseat!"
                    subTitle="Schedule an demo with one of our experienced <br />professionals today!"
                />
            </Section>
            <Section bottomMd={190} bottomLg={145} bottomXl={105}>
                <AboutSectionStyle3
                    titleUp="Decades of expertise and market leadership. A distinguished history of 
                     innovative Healthcare Solutions."
                    title="Meet The Minds Behind Medna Data Systems"
                    subTitle="Building compliant, scalable healthcare technology for the UAE.
Medna Data Systems is a healthcare technology company focused on delivering a robust, 
regulatory-ready Healthcare ERP and HMIS platform for clinics and hospitals operating in the UAE.
We bring together deep technical expertise, healthcare domain knowledge, and real-world implementation
 experience to solve one core problem: making healthcare operations simpler, compliant, and efficient
  without compromising patient data or clinical workflows."
                    imgUrl={about}
                />
            </Section>
            <Section>
                <AppointmentSectionStyle2
                    bgUrl={process.env.PUBLIC_URL + "/images/home_2/appointment_bg.svg"}
                    imgUrl={a2}
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                />
            </Section>
            {/* <Section
                topMd={200}
                topLg={150}
                topXl={110}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BrandsSectionStyle2 data={brandData} />
            </Section> */}
        </>
    );
}
